import { Pool } from 'templates/pool/types';

export const isPoolVerified = (pool?: Pool): boolean => {
  if (!pool) return false;
  return pool.verified === true || pool.isVerified === true;
}; 